import { MutationTree } from 'vuex';
import {
  MobileState,
  PlanItem,
  OptionItem,
  TerminalItem,
  PlanPayload,
  OptionPayload,
  TerminalPayload,
} from '@/store/Mobile/state';
import { MobileConfig } from '@/data/mobileConfig';
import { Carrier } from '@/data/mobile/carrier';
import { Plan } from '@/data/mobile/plan';
import { Option } from '@/data/mobile/option';
import { Terminal } from '@/data/mobile/terminal';

// tslint:disable-next-line:no-var-requires
const _ = require('lodash');

type Payload = PlanPayload | OptionPayload | TerminalPayload;
type Item = PlanItem | OptionItem | TerminalItem;

const buildItem = (payload: Payload, old: Item, count: number): Item => {
  switch (payload.stateKey) {
    case 'plans':
      return {
        id: payload.id as string,
        carrier: payload.carrier,
        simType: payload.simType,
        count: count,
      };
    case 'options':
      return {
        id: payload.id as string,
        carrier: payload.carrier,
        simType: payload.simType,
        groupId: (old as OptionItem).groupId,
        count: count,
      };
    case 'terminals':
      return {
        id: payload.id as string,
        count: count,
      };
  }
};

const findIndex = (list: Item[], payload: Payload) => {
  return list.findIndex((i: Item) => {
    const is_equal_id = i.id && i.id === payload.id;
    const is_equal_carrier =
      'carrier' in payload && 'carrier' in i
        ? i.carrier === payload.carrier
        : true;
    const is_equal_sim_type =
      'simType' in payload && 'simType' in i
        ? i.simType === payload.simType
        : true;
    return i && is_equal_id && is_equal_carrier && is_equal_sim_type;
  });
};

const plansInitialize = (config: MobileConfig): PlanItem[] => {
  return config.plans.reduce((z: PlanItem[], plan: Plan) => {
    _.each(plan.carriers, (carrier: Carrier) => {
      z.push({
        id: plan.id,
        simType: plan.simType.id,
        carrier: carrier.id,
        count: 0,
      });
    });
    return z;
  }, []);
};

const optionsInitialize = (config: MobileConfig): OptionItem[] => {
  return config.options.reduce((z: OptionItem[], option: Option) => {
    _.each(option.simIds, (simTypeId: string) => {
      _.each(option.carriers, (carrier: Carrier) => {
        z.push({
          id: option.id,
          carrier: carrier.id,
          simType: simTypeId,
          groupId: option.groupId,
          count: 0,
        });
      });
    });
    return z;
  }, []);
};

const terminalsInitialize = (config: MobileConfig): TerminalItem[] => {
  return config.terminals.reduce((z: TerminalItem[], terminal: Terminal) => {
    z.push({ id: terminal.id, count: 0 });
    return z;
  }, []);
};

const mutations: MutationTree<MobileState> = {
  initialize: (state, config: MobileConfig) => {
    state.plans = plansInitialize(config);
    state.options = optionsInitialize(config);
    state.terminals = terminalsInitialize(config);
  },
  update: (state, payload: Payload) => {
    const index = findIndex(state[payload.stateKey], payload);
    const count = payload.count as number;
    state[payload.stateKey].splice(
      index,
      1,
      buildItem(payload, state[payload.stateKey][index], count)
    );
  },
};

export default mutations;
